import { Box, useBreakpointValue } from "@chakra-ui/react"
import styled from "styled-components"
import { TileProduct, TileSparePart } from "../../common/types/global"
import breakpoints from "../../theme/chakra/foundation/breakpoints"
import GeberitCarousel from "./Geberit/GeberitCarousel"
import { BasicSearchTile } from "./Tiles/BasicSearchTile"

type Props = {
  items: (TileProduct & TileSparePart)[]
}

// Additional styling for the Geberit carousel component to fit OCNext tiles carousels designs
const CarouselWrapper = styled(Box)`
  .swiper-slide:last-child > article:after {
    content: none;
  }

  .swiper-slide {
    min-width: 300px;
    max-width: 300px;
  }

  @media (max-width: ${breakpoints.xs}) {
    .swiper-slide {
      min-width: 288px;
      max-width: ${breakpoints.xs};
    }
  }

  @media (min-width: ${breakpoints.xs}) and (max-width: ${breakpoints.md}) {
    .swiper-slide {
      min-width: 360px;
      max-width: 360px;
    }
  }
`

export const CarouselTiles = ({ items }: Props) => {
  const slideMargin = useBreakpointValue({ base: 12, xs: 0, md: 12 })

  const slidesToShowSmall = useBreakpointValue({ base: 1, xs: 2 })
  const slidesToShowLarge = useBreakpointValue({ base: 3.5, md: 3, lg: 3.5 })
  const slidesToShow = useBreakpointValue({ base: 1, xs: 2, sm: 2, md: 3, lg: 3.5 })

  const hideIndicator = slidesToShow >= items?.length

  const responsiveLayout = {
    small: { slides: slidesToShowSmall, slidesToMove: 1 },
    medium: { slides: slidesToShowSmall, slidesToMove: 1 },
    large: { slides: slidesToShowLarge, slidesToMove: 1 },
  }

  return (
    <CarouselWrapper>
      <GeberitCarousel
        responsiveLayout={responsiveLayout}
        hideIndicator={hideIndicator}
        slideMargin={slideMargin}
        /* This is to make the component re-render when we switch between md and lg Chakra breakpoints by dragging window
            We want to split the GDDS Carousel component "large" breakpoint in two because it doesn't fit our designs, 
            so we need two different values fitting into "large" */
        key={JSON.stringify(responsiveLayout)}
      >
        {items.map((item) => (
          <BasicSearchTile key={item.id} item={item} />
        ))}
      </GeberitCarousel>
    </CarouselWrapper>
  )
}
